import { render, staticRenderFns } from "./StorageDetail.vue?vue&type=template&id=4f0f7d74&scoped=true&"
import script from "./StorageDetail.vue?vue&type=script&lang=js&"
export * from "./StorageDetail.vue?vue&type=script&lang=js&"
import style0 from "./StorageDetail.vue?vue&type=style&index=0&id=4f0f7d74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0f7d74",
  null
  
)

export default component.exports